import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import "./AddLabel.css";
import { useTheme } from "../../../../components/hooks/useTheme";
import { iconValues } from "../../../../utils/iconValues";

type Props = {
  data: {
    id: number;
    label: string;
    link: string;
    isActive: boolean;
    isOnTopBar: boolean;
    isOpenInNewTab: boolean;
    topBarIcon: string;
    userId: string;
  };
  handleDelete: (id: number) => void;
  handleTheChange: (
    id: number,
    label: string,
    link: string,
    isActive: boolean,
    isOnTopBar: boolean,
    isOpenInNewTab: boolean,
    topBarIcon: string,
    userId: string,
  ) => void;
  users: any[];
};


export const AddLabel = (props: Props) => {
  const { themeStyles } = useTheme();
  const [selectedTopBarIcon, setSelectedTopBarIcon] = useState(
    iconValues.find((item: any) => item.value === props.data.topBarIcon)
  );
  const [userId, setUserId] = useState(props.data.userId);
  const [label, setLabel] = useState(props.data.label);
  const [link, setLink] = useState(props.data.link);
  const [isActive, setIsActive] = useState(props.data.isActive);
  const [isOnTopBar, setIsOnTopBar] = useState(props.data.isOnTopBar);
  const [isOpenInNewTab, setIsOpenInNewTab] = useState(
    props.data.isOpenInNewTab
  );
  const [topBarIcon, setTopBarIcon] = useState(props.data.topBarIcon);

  const Option = (props: any) => (
    <components.Option {...props} className="top-bar-icon-option">
      <span className={`material-symbols-outlined text-[16px] mr-[3px] font-normal ${themeStyles.form.tailwindInputTextColor} cursor-pointer`}>{props.data.icon}</span>
      {props.data.label}
    </components.Option>
  );

  const handleChange = (value: any) => {
    setSelectedTopBarIcon(value);
    setTopBarIcon(value.value);
  };

  const SingleValue = ({ children, ...props }: any) => (
    <components.SingleValue {...props}>
      <span className={`material-symbols-outlined text-[16px] mr-[3px] font-normal ${themeStyles.form.tailwindInputTextColor} cursor-pointer`}>{selectedTopBarIcon?.icon}</span>
      {children}
    </components.SingleValue>
  );


  useEffect(() => {
    props.handleTheChange(props.data.id, label, link, isActive, isOnTopBar, isOpenInNewTab, topBarIcon, userId,);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [label, link, isActive, isOnTopBar, isOpenInNewTab, topBarIcon, userId]);

  return (
    <div className="w-full flex flex-row justify-center items-center px-6 mb-2">
      <div className="w-1/4 mr-2">
        <input
          type="text"
          name="label"
          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          required
        />
      </div>

      <div className="w-1/4 mr-2">
        <input
          type="text"
          name="link"
          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
          value={link}
          onChange={(e) => setLink(e.target.value)}
          required
        />
      </div>

      <div className="w-[10%] mr-2">
        <select
          name="active"
          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
          value={isActive ? "Yes" : "No"}
          onChange={(e) => setIsActive(e.target.value === "Yes")}
        >
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>

      <div className="w-[10%] mr-2">
        <select
          name="onTopBar"
          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
          value={isOnTopBar ? "Yes" : "No"}
          onChange={(e) => setIsOnTopBar(e.target.value === "Yes")}
        >
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>

      <div className="w-[10%] mr-2">
        <select
          name="openInNewTab"
          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
          value={isOpenInNewTab ? "Yes" : "No"}
          onChange={(e) => setIsOpenInNewTab(e.target.value === "Yes")}
        >
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>

      <div className="w-[15%] mr-2">
        <Select
          value={selectedTopBarIcon}
          options={iconValues}
          onChange={handleChange}
          styles={{
            control: (base, state) => ({
              ...base,
              backgroundColor: "transparent",
              color: themeStyles.form.inputTextColor,
              borderRadius: '6px',
              borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
            }),
            menu: (base) => ({
              ...base,
              fontSize: "10px",
              backgroundColor: themeStyles.main.mainBg,
              color: themeStyles.form.inputTextColor,
            }),
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isSelected
                ? "#167AC3"
                : state.isFocused
                  ? themeStyles.topBar.menuItemsHoverColor
                  : "transparent",
              color: state.isSelected ? "white" : themeStyles.topBar.textColor,
            }),
            input: (base) => ({
              ...base,
              color: themeStyles.form.inputTextColor,

            }),
            singleValue: (base) => ({
              ...base,
              display: "flex",
              alignItems: "center",
              paddingBlock: "0px",
              color: themeStyles.form.inputTextColor,
            }),
          }}
          components={{
            Option,
            SingleValue,
          }}
        />
      </div>

      <div className="w-[15%] mr-2">
        <select
          name="user"
          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
          value={userId}
          onChange={(e) => {
            setUserId(e.target.value);
          }}
        >
          {props.users.map((user: any) => (
            <option key={user.value} value={user.value}>
              {user.label}
            </option>
          ))}
        </select>
      </div>

      <div className="w-[5%]">
        <span className={`material-symbols-outlined text-[25px] font-medium text-red-500 cursor-pointer`} onClick={() => props.handleDelete(props.data.id)}>
          delete
        </span>
      </div>
    </div>

  );
};
